export default __webpack_public_path__ + "static/media/atom.d6ab40ff.jfif";